"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertPlantsEcoline = void 0;
const StandardActionCard_1 = require("../../StandardActionCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const constants_1 = require("../../../constants");
const SelectSpace_1 = require("../../../inputs/SelectSpace");
const Card_1 = require("../../Card");
const TileType_1 = require("../../../TileType");
const RedsPolicy_1 = require("../../../turmoil/RedsPolicy");
class ConvertPlantsEcoline extends StandardActionCard_1.StandardActionCard {
    constructor() {
        super({
            name: CardName_1.CardName.CONVERT_PLANTS_ECOLINE,
            tr: { oxygen: 1 },
            metadata: {
                cardNumber: 'SA3',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject('Spend 7 Plants to place a greenery tile and raise oxygen 1 step.', (eb) => {
                    eb.plants(7).startAction.greenery();
                })),
            },
        });
    }
    canAct(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this, false, 'take this action');
        if (player.plants < player.plantsNeededForGreenery) {
            return false;
        }
        if (player.game.board.getAvailableSpacesForGreenery(player).length === 0) {
            return false;
        }
        if (player.game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL) {
            return true;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromOxygenIncrease(1) ? 2 : 0;
            const actionDetails = new RedsPolicy_1.ActionDetails({
                oxygenIncrease: 1,
                nonOceanToPlace: TileType_1.TileType.GREENERY,
                nonOceanAvailableSpaces: player.game.board.getAvailableSpacesForGreenery(player),
                bonusMegaCredits: bonusMegaCredits,
            });
            const howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            return howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        return new SelectSpace_1.SelectSpace(`Convert ${player.plantsNeededForGreenery} plants into greenery`, player.game.board.getAvailableSpacesForGreenery(player), TileType_1.TileType.GREENERY, (space) => {
            this.actionUsed(player);
            player.game.addGreenery(player, space.id);
            player.plants -= player.plantsNeededForGreenery;
            return undefined;
        });
    }
}
exports.ConvertPlantsEcoline = ConvertPlantsEcoline;
//# sourceMappingURL=ConvertPlantsEcoline.js.map